module.exports = __webpack_public_path__ + "img/hr-covid.d308addb.png";